import { render, staticRenderFns } from "./antecedenteObstetrico.vue?vue&type=template&id=85e1788c"
import script from "./antecedenteObstetrico.vue?vue&type=script&lang=js"
export * from "./antecedenteObstetrico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports